<div *adaptLoading="!initialised"
     class="chart-wrapper">
    <dx-chart class="chart-dimension"
              [dataSource]="chartData"
              [rotated]="presentResponseGroups.length > 1"
              [customizePoint]="customiseChartPoint"
              (onPointClick)="onPointClicked($event)"
              (onDone)="updateChartDimensionAndSubscribeSizeChange($event)">
        @if (showTitle) {
            <dxo-chart-title text="{{ surveyName }} scores by {{ analyseTargetLabel.toLowerCase() }}">
                <dxo-chart-font [size]="22"
                                [weight]="400"></dxo-chart-font>
            </dxo-chart-title>
        }
        <dxo-chart-animation [enabled]="false"></dxo-chart-animation>
        <dxo-chart-common-series-settings>
            <dxo-chart-label [visible]="presentResponseGroups.length > 1"
                             position="inside"
                             backgroundColor="#00000000"
                             [horizontalOffset]="-2000"
                             [customizeText]="customiseChartText"></dxo-chart-label>
        </dxo-chart-common-series-settings>
        @if (presentResponseGroups.indexOf(ResponseGroup.All) >= 0) {
            <dxi-chart-series type="bar"
                              [tag]="ResponseGroup.All"
                              valueField="All"
                              [argumentField]="!isSmallWidth ? 'category' : 'categoryShortName'"
                              name="Category Average"> </dxi-chart-series>
        }
        @if (presentResponseGroups.indexOf(ResponseGroup.Leader) >= 0) {
            <dxi-chart-series type="bar"
                              [tag]="ResponseGroup.Leader"
                              valueField="Leader"
                              [argumentField]="!isSmallWidth ? 'category' : 'categoryShortName'"
                              name="Leaders Average"> </dxi-chart-series>
        }
        @if (presentResponseGroups.indexOf(ResponseGroup.NonLeader) >= 0) {
            <dxi-chart-series type="bar"
                              [tag]="ResponseGroup.NonLeader"
                              valueField="NonLeader"
                              [argumentField]="!isSmallWidth ? 'category' : 'categoryShortName'"
                              name="Employees Average"> </dxi-chart-series>
        }
        <dxi-chart-value-axis [allowDecimals]="false"
                              [valueMarginsEnabled]="false"
                              [showZero]="true"
                              [visualRange]="[0, 100]"
                              visualRangeUpdateMode="keep">
            @if (!isSmallWidth) {
                <dxo-chart-title text="Percentage score"></dxo-chart-title>
            }
            <dxo-chart-label [customizeText]="pointToPercentage"></dxo-chart-label>
        </dxi-chart-value-axis>
        <dxo-chart-argument-axis [inverted]="presentResponseGroups.length > 1">
            @if (!isSmallWidth) {
                <dxo-chart-title text="{{ analyseTargetLabel }}"></dxo-chart-title>
            }
            <dxo-chart-label [overlappingBehavior]="isSmallWidth ? 'rotate' : 'none'"
                             [customizeText]="customiseXAxisText">
                <dxo-chart-font [size]="14"></dxo-chart-font>
            </dxo-chart-label>
        </dxo-chart-argument-axis>
        <dxo-chart-tooltip [enabled]="true"
                           [customizeTooltip]="customiseChartTooltip"></dxo-chart-tooltip>
        <dxo-chart-legend [visible]="false"></dxo-chart-legend>
    </dx-chart>
</div>
